<script setup>
  import { NIcon } from 'naive-ui'
  import { WindowMaximize } from '@vicons/fa'
  import { useFullscreen } from '@vueuse/core'
  import { inject } from 'vue'
  const appLayoutRef = inject('appLayoutRef')
  const { toggle } = useFullscreen(appLayoutRef)
</script>
<template>
  <NIcon
    title="Toggle FullScreen Mode"
    @click="toggle"
    ><WindowMaximize
  /></NIcon>
</template>
